import { AudioPlayer } from 'CMFW/layout/AudioPlayer';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { createKeyPath } from '../../CMFW/context/helper/keyContext';
import KeyContext from '../../CMFW/context/KeyContext';
import ModuleContext from '../../CMFW/context/ModuleContext';

type IProps = {
  targetCode: string;
  index: number;
};

export const AudioPlayerTarget: React.FC<IProps> = (props) => {
  const module = useContext(ModuleContext);
  
  // Extract cultural voc ID and use index as dialect identifier  
  const culturalVocId = module.getItemId();
  
  return (
    <KeyContext.Provider value={createKeyPath('', 'targets', props.index)} key={props.index}>
      <Container>
        <span>{props.targetCode}</span>
        <AudioPlayer key={`audio-${culturalVocId}-${props.index}`} />
      </Container>
    </KeyContext.Provider>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
`;
